import { combineReducers } from "redux";

import { login } from "./auth";
import { updateOffset } from "./pagination";

const rootReducer = combineReducers({
  login,
  updateOffset,
});

export default rootReducer;
